module.exports = __webpack_public_path__ + "static/media/mixto-min.fc413a91.png";